import axios from 'axios'
import { clearAuth, getToken } from '../utils/auth'
import { extractApiError, isHtmlApiResponse, isPublicAuthPath } from './error'
import { API_BASE } from './config'
import router from '../router'

const http = axios.create({
  baseURL: API_BASE,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json'
  }
})

http.interceptors.request.use((config) => {
  if (!isPublicAuthPath(config.url)) {
    const token = getToken()
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
  }
  return config
})

http.interceptors.response.use(
  (response) => {
    if (isHtmlApiResponse(response)) {
      const err = new Error(
        'API 请求被静态页面拦截：请配置 Nginx /api/ 反代，或设置 VUE_APP_API_BASE 为 https://lc.k2yun.com/api/v1'
      )
      err.response = response
      return Promise.reject(err)
    }
    return response
  },
  (error) => {
    const status = error.response?.status
    const onLoginPage = router.currentRoute.value.name === 'login'
    if (status === 401 && !onLoginPage && !isPublicAuthPath(error.config?.url)) {
      clearAuth()
      const current = router.currentRoute.value
      if (current.meta?.requiresAuth) {
        router.push({ name: 'login', query: { redirect: current.fullPath } })
      }
    }
    error.displayMessage = extractApiError(error)
    return Promise.reject(error)
  }
)

export default http
